import React from 'react';
import './DeleteButton.scss';

interface DeleteButtonProps {
  /** Function to handle delete action */
  onDelete: () => void;
  /** Custom class name */
  className?: string;
  /** Whether button is disabled */
  disabled?: boolean;
  /** Number of selected items */
  selectedItemsCount?: number;
  /** Custom label */
  label?: string;
}

/**
 * Generic Delete button component
 * Shows count of selected items and is disabled when no items selected
 */
const DeleteButton: React.FC<DeleteButtonProps> = ({
  onDelete,
  className = '',
  disabled = false,
  selectedItemsCount = 0,
  label
}) => {
  const buttonLabel = label || `Delete (${selectedItemsCount})`;
  const isDisabled = disabled || selectedItemsCount === 0;

  const handleClick = () => {
    if (selectedItemsCount === 0) return;
    
    // Call onDelete directly - let the parent component handle confirmation
    // This allows custom confirmation modals to be used
    onDelete();
  };

  return (
    <button
      className={`delete-button ${className}`}
      onClick={handleClick}
      disabled={isDisabled}
      type="button"
    >
      {buttonLabel}
    </button>
  );
};

export default DeleteButton;
